import {StyleSheet} from 'react-native';

import {cloudLight, onyx} from '/theme/color/on.color';
import {chestnut, pine} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  heading: {
    marginBottom: 10,
    ...getFontFamily('normal'),
  },
  subheading: {
    paddingTop: 40,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemDate: {
    marginBottom: 4,
  },
  expired: {
    color: chestnut,
  },
  earned: {
    color: pine,
  },
  redeemed: {
    color: onyx,
  },
});
